import { useRouter } from 'next/router';

export const useIsLevelUpCheckoutPage = () => {
  const router = useRouter();

  return router.route === '/levelup/[merchantId]/[checkNumber]';
};
